'use strict';
import angular from 'angular';
var TapIntegrativePageController = /** @class */ (function () {
    /*@ngInject*/
    function TapIntegrativePageController(TapIntegrativePageService, $mdDialog, $scope) {
        $scope.vm.isHeroTabs = false;
        this.$mdDialog = $mdDialog;
        TapIntegrativePageService.getTapIntegrativeData()
            .then(function (response) {
            //TODO : Set the this.dataset once the api is available
        });
        this.showTapMedia = function (event, url, mediaType) {
            $mdDialog.show({
                controllerAs: "tapMediaCtrl",
                bindToController: true,
                controller: function ($mdDialog) {
                    this.mediaUrl = url;
                    this.mediaType = mediaType;
                },
                template: require('./tap-integrative-media.html'),
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose: true,
                fullscreen: false,
            });
        };
        //TODO : Need to remove the below code once the API for tap integrative is available
        var resp = {
            "response": {
                "audio": [
                    {
                        "url": "../../../assets/audio/Emerson1_Berberine.mp3",
                        "name": "Berberine & Brain Injuries"
                    },
                    {
                        "url": "../../../assets/audio/Emerson2_Curcumin.mp3",
                        "name": "Curcumin's Effects on Systemic Inflammation"
                    },
                    {
                        "url": "../../../assets/audio/Emerson3_Epigenetics.mp3",
                        "name": "Role of Epigenetic Modifications in Cardiovascular Disease"
                    },
                    {
                        "url": "../../../assets/audio/Emerson4_VitaminD.mp3",
                        "name": "Vitamin D Deficiency's & Rheumatoid Arthritis"
                    }
                ],
                "video": [
                    {
                        "url": "../../../assets/videos/Emerson-Q1-final-TAP 720.mp4",
                        "name": "Evaluating a Patients Willingness to Change"
                    },
                    {
                        "url": "../../../assets/videos/Emerson-Q2-final-TAP 720.mp4",
                        "name": "Strategies to Promote Patient Success"
                    },
                    {
                        "url": "../../../assets/videos/Emerson-Q3-final-TAP 720.mp4",
                        "name": "The Importance of Community in Positive Patient Outcomes"
                    },
                    {
                        "url": "../../../assets/videos/Emerson-Q4-final-TAP 720.mp4",
                        "name": "Discussing Drive, Purpose or Spirituality with Patients"
                    }
                ]
            },
            "error": {},
            "warnings": {}
        };
        //TODO : need to remove the below code once the api is ready
        this.dataset = resp.response;
    }
    return TapIntegrativePageController;
}());
export default TapIntegrativePageController;
//# sourceMappingURL=tap-integrative-page.controller.js.map